module.exports = __webpack_public_path__ + "assets/6a9480cd4f1b3b63c36609c79bf99c25.mp4";